module.exports = __webpack_public_path__ + "static/media/trash-icon.aec1eac4.svg";